import { render, staticRenderFns } from "./PestsReports.vue?vue&type=template&id=56d51abe&scoped=true&"
import script from "./PestsReports.vue?vue&type=script&lang=js&"
export * from "./PestsReports.vue?vue&type=script&lang=js&"
import style0 from "./PestsReports.vue?vue&type=style&index=0&id=56d51abe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d51abe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/abimelec/repositories/nxtagro_op_front/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VContainer,VDataTable,VDialog,VDivider,VFlex,VIcon,VLayout,VSpacer,VTextField,VToolbar,VToolbarTitle})
